export default {
	status: {
		All: "すべて",
		Pending: "保留中です",
		Frozen: "凍結",
		Completed: "終わりました",
		Undone: "未完です"
	},
	TotalAmount: "合計金額",
	Profit: "利益",
	Expire: "期限切れ"
};
